import React from "react";
import { Stack } from "../../../Stacks/Stack/Stack";

export interface CustomColumnProps {
    /**
     * children elements to append to the column.
     */
    readonly children: React.ReactNode;
}

export const CustomColumn: React.FC<CustomColumnProps> = ({
    children
}) => (
    <Stack>
        {children}
    </Stack>
);
